import { CustomerTaskDto } from "./CustomerTaskDto";
import { CustomerTaskModel } from "./CustomerTaskModel";

export const transformCustomerTaskDtoToModel = (
  dto: CustomerTaskDto
): CustomerTaskModel => dto;
